/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AorvExcelHochladenRequest
 */
export interface AorvExcelHochladenRequest {
    /**
     * Die in base64 enkodierte Excel Datei.
     * @type {string}
     * @memberof AorvExcelHochladenRequest
     */
    excel: string;
    /**
     * Das Jahr, für das importiert werden soll.
     * @type {number}
     * @memberof AorvExcelHochladenRequest
     */
    jahr: number;
    /**
     * Der Name der Excel Datei.
     * @type {string}
     * @memberof AorvExcelHochladenRequest
     */
    dateiName: string;
}

/**
 * Check if a given object implements the AorvExcelHochladenRequest interface.
 */
export function instanceOfAorvExcelHochladenRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "excel" in value;
    isInstance = isInstance && "jahr" in value;
    isInstance = isInstance && "dateiName" in value;

    return isInstance;
}

export function AorvExcelHochladenRequestFromJSON(json: any): AorvExcelHochladenRequest {
    return AorvExcelHochladenRequestFromJSONTyped(json, false);
}

export function AorvExcelHochladenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvExcelHochladenRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'excel': json['excel'],
        'jahr': json['jahr'],
        'dateiName': json['dateiName'],
    };
}

export function AorvExcelHochladenRequestToJSON(value?: AorvExcelHochladenRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'excel': value.excel,
        'jahr': value.jahr,
        'dateiName': value.dateiName,
    };
}

